import {useEffect} from 'react';
import {InteractionLottie} from '@di-shared/features/about/About';
import GlobalErrorBoundary, {GlobalErrorBoundaryProps} from '@di-shared/features/common/GlobalErrorBoundary/index';
import Header from '@di-shared/features/common/Header';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import useApiError from '@di-shared/features/common/useApiError';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {getDatadogSessionId, setDatadogUnExpectedError} from '@di-shared/utils/datadog';

export default function ({error}: GlobalErrorBoundaryProps) {
  const {t} = useInferableTranslation();
  const {backOrClose} = useCcWebviewUtilsHelper();
  const {getErrorCode} = useApiError();

  useEffect(() => {
    const GlobalErrorboundaryError = new Error(JSON.stringify(error));
    GlobalErrorboundaryError.stack = (error as any).message;
    GlobalErrorboundaryError.name = GlobalErrorBoundary.name;
    setDatadogUnExpectedError(GlobalErrorBoundary.name, error);
  }, []);

  return (
    <div className="wrap">
      <Header right={<HeaderCloseButton />} />
      <main className="content page_error">
        <div className="empty_section">
          {(import.meta.env.VITE_PROFILE === 'dev' || import.meta.env.VITE_PROFILE === 'local') && (
            <p className="body_small_r empty_section_text">{(error as any)?.statusText || (error as any)?.message}</p>
          )}
          <div className="loading_lottie loading_lottie_motion">
            <InteractionLottie
              kiaLightSrc={() => import('@di-shared/assets/img/json/block_motion_light.json')}
              kiaDarkSrc={() => import('@di-shared/assets/img/json/block_motion.json')}
              hyundaiLightSrc={() => import('@di-shared/assets/img/json/block_motion_light.json')}
              hyundaiDarkSrc={() => import('@di-shared/assets/img/json/block_motion.json')}
              genesisLightSrc={() => import('@di-shared/assets/img/json/block_motion_light.json')}
              genesisDarkSrc={() => import('@di-shared/assets/img/json/block_motion.json')}
              loop={false}
              autoplay={false}
            />
          </div>
          <h2 className="empty_section_title">{t('T20096')}</h2>
          <p
            className="empty_section_text"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {t('T20097')}
          </p>
          <p
            className="empty_section_text"
            style={{whiteSpace: 'pre-wrap'}}
          >
            {`error: ${getDatadogSessionId() ? `${getDatadogSessionId()}-` : ''}${getErrorCode(error)}`}
          </p>
          <div className="btn_box">
            <button
              type="button"
              className="btn btn_filled_tonal"
              onClick={() => backOrClose()}
            >
              {t('T10051')}
            </button>
          </div>

          {/* fixme 기획 문의 필요 */}
          {/*<div className="btn_box">*/}
          {/*  <button*/}
          {/*    type="button"*/}
          {/*    className="btn btn_filled_tonal"*/}
          {/*  >*/}
          {/*    다시 시도하기*/}
          {/*  </button>*/}
          {/*  <button*/}
          {/*    type="button"*/}
          {/*    className="btn btn_outline_sub"*/}
          {/*  >*/}
          {/*    고객센터 문의*/}
          {/*  </button>*/}
          {/*</div>*/}
        </div>
      </main>
    </div>
  );
}
